import { useState } from "react";
import { api } from "@/lib/api";
import { SealCheck, XCircle, CheckCircle, FileText } from "@phosphor-icons/react";
import { Field, SelectField } from "./shared";

const RELIEFS = [
  { value: "EII", label: "EII" },
  { value: "SURE", label: "SURE" },
  { value: "R&D", label: "R&D" },
];
const TRADING = [
  { value: "active", label: "Active" },
  { value: "dormant", label: "Dormant" },
];

export default function EligibilityCheck() {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ company_name: "", incorporation_date: "", trading_status: "active", employee_count: "", annual_turnover: "", relief_type: "EII" });
  const [res, setRes] = useState(null);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const run = async (e) => {
    e.preventDefault();
    try {
      const r = await api.post("/tax/validate-eligibility", {
        company_name: f.company_name,
        incorporation_date: f.incorporation_date,
        trading_status: f.trading_status,
        employee_count: Number(f.employee_count || 0),
        annual_turnover: Number(f.annual_turnover || 0),
        relief_type: f.relief_type,
      });
      setRes(r.data);
    } catch (err) { alert(err?.response?.data?.detail || err.message); }
  };

  return (
    <div className="glass rounded-2xl p-6" data-testid="eligibility-check">
      <button onClick={() => setOpen((o) => !o)} className="flex items-center justify-between w-full text-left" data-testid="eligibility-toggle">
        <div className="flex items-center gap-3">
          <SealCheck size={22} weight="duotone" className="text-[#FFB020]" />
          <div>
            <div className="font-display text-lg">Company eligibility pre-check</div>
            <div className="text-white/50 text-sm">Optional — screen your company before you calculate relief.</div>
          </div>
        </div>
        <span className="text-white/40 text-sm">{open ? "Hide" : "Open"}</span>
      </button>

      {open && (
        <div className="mt-6 grid lg:grid-cols-2 gap-6">
          <form onSubmit={run} className="space-y-4">
            <Field label="Company name" required data-testid="elig-name" value={f.company_name} onChange={(e) => set("company_name", e.target.value)} />
            <div className="grid grid-cols-2 gap-4">
              <Field label="Incorporation date" type="date" required data-testid="elig-incorporation" value={f.incorporation_date} onChange={(e) => set("incorporation_date", e.target.value)} />
              <SelectField label="Relief type" options={RELIEFS} data-testid="elig-relief" value={f.relief_type} onChange={(e) => set("relief_type", e.target.value)} />
            </div>
            <div className="grid grid-cols-3 gap-4">
              <SelectField label="Trading" options={TRADING} data-testid="elig-trading" value={f.trading_status} onChange={(e) => set("trading_status", e.target.value)} />
              <Field label="Employees" type="number" data-testid="elig-employees" value={f.employee_count} onChange={(e) => set("employee_count", e.target.value)} />
              <Field label="Turnover (€)" type="number" data-testid="elig-turnover" value={f.annual_turnover} onChange={(e) => set("annual_turnover", e.target.value)} />
            </div>
            <button type="submit" className="btn-gold" data-testid="elig-check">Check eligibility</button>
          </form>

          {res && (
            <div className="rounded-xl bg-black/30 border border-white/5 p-5 space-y-4" data-testid="elig-result">
              <div className={`flex items-center gap-2 font-semibold ${res.eligible ? "text-[#00A86B]" : "text-[#E63946]"}`}>
                {res.eligible ? <CheckCircle size={20} weight="fill" /> : <XCircle size={20} weight="fill" />}
                {res.eligible ? "Likely eligible (subject to Revenue conditions)" : "Potential issues found"}
              </div>
              <ul className="space-y-1.5 text-sm text-white/75">
                {res.reasons.map((r) => <li key={r}>• {r}</li>)}
              </ul>
              <div>
                <div className="eyebrow mb-2">Documents you&apos;ll need</div>
                <ul className="space-y-1.5 text-sm text-white/70">
                  {res.required_documents.map((d) => (
                    <li key={d} className="flex items-start gap-2"><FileText size={15} className="text-[#FFB020] mt-0.5 shrink-0" /> {d}</li>
                  ))}
                </ul>
              </div>
              <div className="text-xs text-white/45 border-t border-white/5 pt-3">{res.disclaimer}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
